module.exports = "/_next/static/images/1b4aed6f3af2d845bc7e5abc83cf08c9-thumbnail.jpg";